import { render, staticRenderFns } from "./InvoiceDataTable.vue?vue&type=template&id=c0af2e44&scoped=true"
import script from "./InvoiceDataTable.vue?vue&type=script&lang=js"
export * from "./InvoiceDataTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDataTable.vue?vue&type=style&index=0&id=c0af2e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af2e44",
  null
  
)

export default component.exports